import React from 'react';

const Signup = (props) => {

    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

    return (
        <div>
            <div className='py-5 px-4 signin-page'>
                <div className='row'>
                    <div className='col-lg-12 text-center'>
                        <p className='f-25 f-pop-med mb-4'>Sign Up</p>
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className='col-lg-6'>
                        <input type='text' placeholder='First Name' className='f-pop-med form-control p-3 mb-4 f-14' />
                    </div>
                    <div className='col-lg-6'>
                        <input type='text' placeholder='Last Name' className=' f-pop-med form-control p-3 mb-4 f-14' />
                    </div>
                    <div className='col-lg-12'>
                        <input type='email' placeholder='Email Address' className='f-pop-med form-control p-3 mb-4 f-14' />
                    </div>
                    <div className='col-lg-12'>
                        <input type='text' placeholder='Phone Number' className='f-pop-med form-control p-3 mb-4 f-14' />
                    </div>
                    <div className='col-lg-6'>
                        <input type='text' placeholder='Password' className='f-pop-med form-control p-3 mb-4 f-14' />
                    </div>
                    <div className='col-lg-6'>
                        <input type='text' placeholder='Confirm Password' className='f-pop-med form-control p-3 mb-4 f-14' />
                    </div>
                </div>
                <button className='f-pop-med form-control p-3 border-0 bg-grad-login-header f-16 text-white'>Sign up</button>
                <div className='row mt-4'>
                    <div className='col-lg-12 text-center'> 
                        <p className='f-13 f-pop-med '>Already have an Account ?  <span className='text-danger ms-2 cursor_pointr' onClick={()=>{props.handleClickOpen(1)}}>SIGN IN</span> </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Signup;